import { axiosDebugInstance, getRequestOrigin } from '@/axios';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postDebugLogs = async (payload: any) => {
  try {
    await axiosDebugInstance.post(
      '/debug-logs',
      {
        logData: payload,
      },
      {
        headers: {
          'x-request-origin': getRequestOrigin(),
        },
      }
    );
  } catch (e) {
    console.error('Error in logging to the backend', e);
  }
};
